import * as FullStory from '@fullstory/browser';
import { covertTimestampToDate } from '@thoughtspot/date-format-util';
import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import { create } from '@thoughtspot/logger';
import { getBaseReleaseVersion, getClusterId, getCurrentOrgId, getPreferredLocale, getReleaseVersion, getTeamId, getUserEmail, getUserGuid, getUserPersona, isFullStoryEnabled, isTrialVersionEnabled, trialDaysLeftWrapper, } from '@thoughtspot/session-service';
import { FullStoryIdentifyUserProp } from './fullstory-constants';
const logger = create('FullStory Identify API');
export const identifyUserInFullStory = () => {
    if (!isFullStoryEnabled()) {
        return;
    }
    const userGuid = getUserGuid();
    const userProperties = {
        [FullStoryIdentifyUserProp.BASE_RELEASE_VER]: getBaseReleaseVersion(),
        [FullStoryIdentifyUserProp.FULL_RELEASE_VER]: getReleaseVersion(),
        [FullStoryIdentifyUserProp.USER_PERSONA]: getUserPersona(),
        [FullStoryIdentifyUserProp.ORG_ID]: getCurrentOrgId().toString(),
        [FullStoryIdentifyUserProp.CLUSTER_ID]: getClusterId(),
        [FullStoryIdentifyUserProp.TEAM_ID]: getTeamId(),
        [FullStoryIdentifyUserProp.USER_LOCALE]: getPreferredLocale(),
        [FullStoryIdentifyUserProp.TRIAL_EXPIRY_DATE]: covertTimestampToDate(trialDaysLeftWrapper()),
        ...(isTrialVersionEnabled() && {
            [FullStoryIdentifyUserProp.EMAIL_ID]: getUserEmail(),
        }),
    };
    FullStory.identify(userGuid, userProperties);
    const isDebugMode = envFlags.getValue(FLAGS.debug.name) || false;
    if (isDebugMode) {
        logger.info(`Fullstory Identify API called with the following properties:\nUserId: ${userGuid}\nUser Properties: ${JSON.stringify(userProperties, null, 4)}`);
    }
};
//# sourceMappingURL=fullstory-identify.js.map